export default "__VITE_ASSET__BvBCFwEj__"